import type { components } from "../../../api/generated";
import type { PerformanceDetailReport, PerformanceReport } from "../types";

/** 生成契约仅在适配边界使用。 */
export type PerformanceReportRaw = components["schemas"]["PerformanceReport"];

/** 后端字段与当前报表视图一致，保留完整人员、数值和列序。 */
export function mapReport(raw: PerformanceReportRaw): PerformanceReport {
  return raw;
}

export type PerformanceDetailsRaw = components["schemas"]["PerformanceDetailReport"];

/** 保留服务端计次分组、原始证据和附件地址。 */
export function mapDetails(raw: PerformanceDetailsRaw): PerformanceDetailReport {
  return raw;
}
